<script setup lang="ts">
import { computed, onMounted, watch } from 'vue'

import type { EmblaCarouselProps } from './types'
import { useCarousel } from '@shared/fondof-ui/components/molecules/carousel/useCarousel'
import type { HTMLAttributeClass } from '@shared/fondof-ui/types'
import clsx from 'clsx'
import type { EmblaCarouselType } from 'embla-carousel'

const props = defineProps<EmblaCarouselProps & HTMLAttributeClass>()

const emit = defineEmits<{
  emblaApi: [api: EmblaCarouselType | undefined]
  activeIndexChange: [api: EmblaCarouselType | undefined]
}>()

const options = computed(() => props.options)

const { emblaApi } = useCarousel(options, props.modules ?? [])

watch(
  emblaApi,
  (emblaApi) => {
    emit('emblaApi', emblaApi)
  },
  { immediate: true }
)

onMounted(() => {
  emblaApi.value?.on('select', () => {
    emit('activeIndexChange', emblaApi.value)
  })
})
</script>

<template>
  <div :class="clsx('w-full', props.class)">
    <slot />
  </div>
</template>
